import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

export default function LocalLoader({
  open,
  bgcolor = 'black',
}: {
  open: boolean;
  bgcolor?: string;
}) {
  return (
    <>
      <Box
        sx={{
          display: open ? 'flex' : 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
      <Box
        sx={{
          display: open ? 'flex' : 'none',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 100000,
          bgcolor,
          opacity: 0.1,
        }}
      ></Box>
    </>
  );
}
